const zonesCategoriesReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_ZONES_CATEGORIES':
      return action.payload;
    default:
      return state;
  }
};
export default zonesCategoriesReducer;
